// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import LinkTo, { LinkToStyles } from "@store/Library/Components/LinkTo";
import { buttonStyles, buttonThemeStyles } from "@store/Themes/common/mixins/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    text = "text",
    buttonLabel = "buttonLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.text]: string;
        [fields.buttonLabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    inviteYourColleguePage: getPageLinkByPageType(state, constants.pageType.inviteYourColleague),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface InviteYourColleagueCTAStyles {
    widgetWrapper?: InjectableCss;
    hookText?: TypographyProps;
    ctaLink?: LinkToStyles;
}

const referACollegueCTAStyles: InviteYourColleagueCTAStyles = {
    widgetWrapper: {
        css: css`
            ${spacingStyles(pxToRem(32), null)}
            display: flex;
            flex-direction: column;
            align-items: "flex-start";
            gap: ${pxToRem(10)};
        `,
    },
    hookText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.large};
        `,
    },
    ctaLink: {
        link: {
            icon: {
                iconProps: {
                    src: ArrowRight,
                    size: 18,
                    css: css`
                        color: ${getColor("primary")};
                    `,
                },
                position: "right",
            },
            css: css`
                ${x => x.theme.button.tertiary.css}
                padding: ${pxToRem(8, 20)};
                color: ${getColor("primary")};
                border: 1px solid ${getColor("primary")};
                ${buttonThemeStyles("tertiary")};
                ${buttonStyles("tertiary")};
            `,
        },
    },
};

const styles = referACollegueCTAStyles;

const InviteYourColleagueCTA = ({ inviteYourColleguePage, fields: { text, buttonLabel } }: Props) => {
    return (
        <StyledWrapper {...styles.widgetWrapper}>
            <Typography {...styles.hookText}>{text}</Typography>
            <LinkTo title={buttonLabel} pageLink={inviteYourColleguePage} extendedStyles={styles.ctaLink} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(InviteYourColleagueCTA),
    definition: {
        displayName: "Invite Your Colleague CTA",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.text,
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "Bring a colleague onboard. Share the benefits.",
            },
            {
                name: fields.buttonLabel,
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "Invite Your Colleague",
            },
        ],
    },
};

export default widgetModule;
